module.exports = __webpack_public_path__ + "static/media/ariel-lose.b59659ac.png";